/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_Col_CompanyInputs */

const en_portal_scanner_col_company = /** @type {(inputs: Portal_Scanner_Col_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const de_portal_scanner_col_company = /** @type {(inputs: Portal_Scanner_Col_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const fr_portal_scanner_col_company = /** @type {(inputs: Portal_Scanner_Col_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const es_portal_scanner_col_company = /** @type {(inputs: Portal_Scanner_Col_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const it_portal_scanner_col_company = /** @type {(inputs: Portal_Scanner_Col_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const nl_portal_scanner_col_company = /** @type {(inputs: Portal_Scanner_Col_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const pl_portal_scanner_col_company = /** @type {(inputs: Portal_Scanner_Col_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const fi_portal_scanner_col_company = /** @type {(inputs: Portal_Scanner_Col_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const da_portal_scanner_col_company = /** @type {(inputs: Portal_Scanner_Col_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const sv_portal_scanner_col_company = /** @type {(inputs: Portal_Scanner_Col_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

/**
* | output |
* | --- |
* | "Company" |
*
* @param {Portal_Scanner_Col_CompanyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_col_company = /** @type {((inputs?: Portal_Scanner_Col_CompanyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_Col_CompanyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_col_company(inputs)
	if (locale === "fr") return fr_portal_scanner_col_company(inputs)
	if (locale === "es") return es_portal_scanner_col_company(inputs)
	if (locale === "it") return it_portal_scanner_col_company(inputs)
	if (locale === "nl") return nl_portal_scanner_col_company(inputs)
	if (locale === "pl") return pl_portal_scanner_col_company(inputs)
	if (locale === "fi") return fi_portal_scanner_col_company(inputs)
	if (locale === "da") return da_portal_scanner_col_company(inputs)
	if (locale === "sv") return sv_portal_scanner_col_company(inputs)
	return en_portal_scanner_col_company(inputs)
});